import ProductImage from './ProductImage.jsx';

export default ProductImage;


// WEBPACK FOOTER //
// ./src/components/ProductImage/index.jsx